<template>
  <el-dialog
    title="配件出库"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="50%"
    top="5%"
    :close-on-click-modal="false"
  >
    <el-form :model="item" ref="itemform" label-width="120px" :rules="rules">
      <el-form-item label="配件型号" prop="IpcAccessoryModelID">
        <select2
          labelName="NameNumber"
          v-model="item.IpcAccessoryModelID"
          url="ipc/model/accessory/list?order=name"
          clearable
          placeholder="选择配件型号"
          no-data-text="没有配件型号"
          :urlParams="{
            where: {},
          }"
          q="NameNumber:like"
          :qinwhere="true"
          :queryOne="false"
          style="width: 100%"
        ></select2>
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="配件SN" prop="SN">
            <el-input v-model.trim="item.SN"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="质保开始日期" prop="QualityStartAt">
            <el-date-picker
              v-model="item.QualityStartAt"
              style="width: 100%"
              type="date"
              placeholder="请选择日期"
              @change="changeDate"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="出库日期" prop="StockoutAt">
            <el-date-picker
              v-model="item.StockoutAt"
              style="width: 100%"
              type="date"
              placeholder="请选择日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="质保结束日期" prop="QualityEndAt">
            <el-date-picker
              v-model="item.QualityEndAt"
              style="width: 100%"
              type="date"
              placeholder="请选择日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="出库单号" prop="CheckoutNo">
            <el-input
              v-model.trim="item.CheckoutNo"
              placeholder="请输入出库单号"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="客户名称" prop="ClientID">
            <select2
              labelName="ClientName"
              v-model="item.ClientID"
              url="client/list"
              filterable
              :clearable="false"
              placeholder="选择客户"
              no-data-text="没有客户"
              :urlParams="{
                where: {},
              }"
              q="ClientName:like"
              :qinwhere="true"
              :queryOne="false"
              style="width: 100%"
            ></select2>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="出库经办人" prop="Operator">
            <el-input
              v-model.trim="item.Operator"
              placeholder="请输入经办人"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="领用人" prop="Recipient">
            <el-input
              v-model.trim="item.Recipient"
              placeholder="请输入领用人"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="出库备注" prop="StockoutReason">
        <el-input
          v-model.trim="item.StockoutReason"
          :autosize="{ minRows: 2 }"
          type="textarea"
          placeholder="请输入出库备注"
        ></el-input>
      </el-form-item>
      <el-form-item label="文件上传" prop="file">
        <el-upload
          ref="upload"
          action=""
          :http-request="httpRequest"
          :headers="uploadHeader"
          :on-remove="handleRemove"
          :on-error="handleError"
        >
          <el-button size="mini" type="primary">选择文件</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  data() {
    return {
      item: {
        IpcAccessoryModelID: "", //配件型号
        SN: "", //配件SN
        StockoutAt: "", //出库日期
        QualityStartAt: "", //质保开始日期
        QualityEndAt: "", //质保结束日期
        CheckoutNo: "", //出库单号
        ClientID: "", //客户id
        Operator: "", //出库经办人
        Recipient: "", //领用人
        StockoutReason: "", //出库备注
        Attachments: [], //附件
      },
      rules: {
        IpcAccessoryModelID: [
          { required: true, message: "配件型号不能为空", trigger: "blur" },
        ],
        SN: [{ required: true, message: "配件SN不能为空", trigger: "blur" }],
        StockoutAt: [
          { required: true, message: "出库日期不能为空", trigger: "blur" },
        ],
        QualityStartAt: [
          { required: true, message: "质保开始日期不能为空", trigger: "blur" },
        ],
        QualityEndAt: [
          { required: true, message: "质保结束日期不能为空", trigger: "blur" },
        ],
        CheckoutNo: [
          { required: true, message: "出库单号不能为空", trigger: "blur" },
        ],
        ClientID: [
          { required: true, message: "客户名称不能为空", trigger: "blur" },
        ],
        Operator: [
          { required: true, message: "出库经办人不能为空", trigger: "blur" },
        ],
        Recipient: [
          { required: true, message: "领用人不能为空", trigger: "blur" },
        ],
        StockoutReason: [{ max: 64000, message: "内容过多", trigger: "blur" }],
      },
      pager: {
        total: 0,
        page: 1,
        size: -1,
      },
      submitting: false,
      uploadHeader: {
        Authorization: `Bearer ${window.localStorage.getItem("jwtToken")}`,
        Accept: "application/json",
      },
      fileList: [],
      removeList: [],
    };
  },
  methods: {
    onOpen() {
      this.item = this.getEmptyItem();
      const date = new Date();
      this.item.StockoutAt = date;
      this.item.QualityStartAt = date;
      this.item.QualityEndAt = new Date(
        date.getTime() + 3600 * 1000 * 24 * 365
      );
      this.item.Operator = this.$store.state.Auth.user.Name;
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.itemform.resetFields();

      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
      this.fileList = [];
      this.removeList = [];
    },
    changeDate(val) {
      //质保开始日期修改，质保结束日期也自动修改,默认质保开始日期开始一年
      if (val) {
        const date = this.item.QualityStartAt;
        this.item.QualityEndAt = new Date(
          date.getTime() + 3600 * 1000 * 24 * 365
        );
      } else {
        this.item.QualityEndAt = val;
      }
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;

        //排除删除的附件
        if (this.removeList.length !== 0) {
          let urls = [];
          this.removeList.forEach((rid) => {
            this.fileList.forEach((file) => {
              if (rid === file.uid) {
                urls.push(file.url);
              }
            });
          });

          urls.forEach((url) => {
            this.item.Attachments.splice(
              this.item.Attachments.findIndex((item) => item.Url === url),
              1
            );
          });
          this.$axios.delete("ipc/attachmentDelete", {
            data: { urls: urls },
          });
        }

        this.$emit("input", this.item);
        const itemData = { ...this.item };
        // 保存的操作
        this.$axios
          .request({
            url: "ipc/accessory/stock-out",
            method: "post",
            data: itemData,
          })
          .then(() => {
            this.$message.success("出库成功");
            this.submitting = false;

            if (this.fileList.length > 0) {
              this.$refs.upload.clearFiles();
            }
            this.fileList = [];
            this.removeList = [];
            this.$emit("form:created", true);
            this.$emit("form:saved", true);
            this.$emit("update:visible", false);
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
            this.submitting = false;
            this.$emit("form:created", false);
            this.$emit("form:saved", false);
          });
      });
    },
    getEmptyItem() {
      return {
        IpcAccessoryModelID: "", //配件型号
        SN: "", //配件SN
        StockoutAt: "", //出库日期
        QualityStartAt: "", //质保开始日期
        QualityEndAt: "", //质保结束日期
        CheckoutNo: "", //出库单号
        ClientID: "", //客户id
        Operator: "", //出库经办人
        Recipient: "", //领用人
        StockoutReason: "", //出库备注
        Attachments: [], //附件};
      };
    },

    // param是自带参数。 this.$refs.upload.submit() 会自动调用 httpRequest方法.在里面取得file
    httpRequest(params) {
      var formData = new FormData();
      formData.append("file", params.file);
      // formData.append("id", this.item.ID);
      this.$axios
        .post(`ipc/accessory/stock-upload`, formData)
        .then((response) => {
          this.item.Attachments =
            this.item.Attachments === null ? [] : this.item.Attachments;
          this.item.Attachments.push(response.data);

          this.fileList.push({
            uid: params.file.uid,
            url: response.data.Url,
          });
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    handleRemove(file) {
      this.removeList.push(file.uid);
    },
    handleError(err) {
      this.$message.error(err.message.substring(1, err.message.length - 2));
    },
  },
};
</script>
<style scoped>
.el-divider--horizontal {
  margin: 0px 0 12px 0;
}
.el-timeline {
  margin: 0;
  font-size: 10px;
  list-style: none;
}
.el-card__body {
  padding: 5px;
}
.el-timeline-item__timestamp {
  color: #909399;
  line-height: 1;
  font-size: 8px;
}
</style>